export default __webpack_public_path__ + "media/projects/red3-thumb-c7f366b3.svg";